'use client'

import Script from 'next/script'
import { usePathname } from 'next/navigation'

const SKIP_PREFIXES = ['/sign-in', '/sign-up', '/forgot-password']

export function GoogleAds() {
  const pathname = usePathname()
  if (SKIP_PREFIXES.some((p) => pathname?.startsWith(p))) return null

  return (
    <>
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=AW-18098990752"
        strategy="lazyOnload"
      />
      <Script id="google-ads-gtag" strategy="lazyOnload">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-18098990752');
        `}
      </Script>
    </>
  )
}
